import { JeomsinPagePath } from "@Config/jeomsin_page_path";
import { Box } from '@mui/material';
import { useNavigate } from "react-router";
import "./titlebar.css";
import { Spacing, SpacingType } from "@Views/common_component/spacer/spacing";
import useTrackingManager from "@Hooks/tracking/use_tracking_manger";
import { TrackingContentTypeKey } from "@Hooks/tracking/tracking_event_key";

type TitlebarProps = {
    type: TitlebarType,
    title: string,
    leftIcons?: React.ReactNode;
    rightIcons?: React.ReactNode;
    pageGuide?: JeomsinPagePath;
    pageBackEvent?:()=> void,
    fontSizeButtonPressed?: () => void,
    shareButtonPressed?: () => void,
    pageGuideButtonPressd?: () => void;
}

const TitleBar: React.FC<TitlebarProps> = (
    props
) => {
    var returnValue:JSX.Element;
    const navigate = useNavigate();
    const { trackButtonClick, trackSelectContent } = useTrackingManager();
    const histroyBack = () => {
        trackButtonClick("뒤로가기");
        props.pageBackEvent ? props.pageBackEvent() : navigate(-1);
    }
    
    switch(props.type) {
        case TitlebarType.SubPageNoButton:
            returnValue = (
                <>
                <Box className='titlebar sub'>
                    <div className='left-icon'>
                        <img src='/images/common/app_bar_previous.png' onClick={histroyBack}></img>
                    </div>
                    <div className="text-area">
                        <span>{props.title}</span>
                        {
                            props.pageGuide ? (
                                <img width="17px" height="17px" className="guide-btn" src="images/three_minute_counselor_list/info.png" alt="guid" onClick={() => {
                                    if(props.pageGuideButtonPressd){
                                        props.pageGuideButtonPressd();
                                    }
                                    navigate(props.pageGuide!);
                                }}/>
                            ) : <></>
                        }
                    </div>
                    <Box className='right-icon'>
                    </Box>
                </Box>
                <Spacing direction={SpacingType.vertical} gap={56}/>
                </>
            );
            break;
        case TitlebarType.SubPageOneButton:
            returnValue = (
                <>
                <Box className='titlebar sub'>
                    <div className='left-icon'>
                        <img src='/images/common/app_bar_previous.png' onClick={histroyBack}></img>
                    </div> 
                    <div className="text-area">
                        <span>{props.title}</span>
                        {
                            props.pageGuide ? (
                                <img width="17px" height="17px" className="guide-btn" src="images/three_minute_counselor_list/info.png" alt="guid" onClick={() => {
                                    if(props.pageGuideButtonPressd){
                                        props.pageGuideButtonPressd();
                                    }
                                    navigate(props.pageGuide!);
                                }}/>
                            ) : <></>
                        }
                    </div>
                    <Box className='right-icon'>
                        <div className="trailing-icon" onClick={() => {
                            if (props.fontSizeButtonPressed) {
                                props.fontSizeButtonPressed();
                            }
                        }}>
                            <img src='img/font.png' alt="font size change"/>
                        </div>
                    </Box>
                </Box>
                <Spacing direction={SpacingType.vertical} gap={56}/>
                </>
            );
            break;
        case TitlebarType.SajuMyeongsik:
            returnValue = (
                <>
                <Box className='titlebar sub'>
                    <div className='left-icon'>
                        <img src='/images/common/app_bar_previous.png' onClick={histroyBack}></img>
                    </div> 
                    <div className="text-area">
                        <span>{props.title}</span>
                        {
                            props.pageGuide ? (
                                <img width="17px" height="17px" className="guide-btn" src="images/three_minute_counselor_list/info.png" alt="guide" onClick={() => {
                                    if(props.pageGuideButtonPressd){
                                        props.pageGuideButtonPressd();
                                    }
                                    navigate(props.pageGuide!);
                                }}/>
                            ) : <></>
                        }
                    </div>
                    <Box className='right-icon'>
                        <div className="trailing-icon" onClick={() => {
                            if (props.shareButtonPressed) {
                                props.shareButtonPressed();
                            }
                        }}>
                            <img src='images/common/app_bar_share.png' alt="share contents"/>
                        </div>
                    </Box>
                </Box>
                <Spacing direction={SpacingType.vertical} gap={56}/>
                </>
            );
            break;
        case TitlebarType.SubPageTwoButton:
            returnValue = (
                <>
                <Box className='titlebar sub'>
                    <div className='left-icon'>
                        <img src='/images/common/app_bar_previous.png' onClick={histroyBack}></img>
                    </div> 
                    <div className="text-area">
                        <span>{props.title}</span>
                        {
                            props.pageGuide ? (
                                <img width="17px" height="17px" className="guide-btn" src="images/three_minute_counselor_list/info.png" alt="guide" onClick={() => {
                                    if(props.pageGuideButtonPressd){
                                        props.pageGuideButtonPressd();
                                    }
                                    navigate(props.pageGuide!);
                                }}/>
                            ) : <></>
                        }
                    </div>
                    <Box className='right-icon'>
                        <div className="trailing-icon" onClick={() => {
                            if (props.fontSizeButtonPressed) {
                                props.fontSizeButtonPressed();
                            }
                        }}>
                            <img src='/images/common/font.png' alt="font size change"/>
                        </div>
                        <div className="trailing-icon" onClick={() => {
                            if (props.shareButtonPressed) {
                                props.shareButtonPressed();
                            }
                        }}>
                            <img src='/images/common/app_bar_share.png' alt="share contents"/>
                        </div>
                    </Box>
                </Box>
                <Spacing direction={SpacingType.vertical} gap={56}/>
                </>
            );
            break;
        case TitlebarType.SubPageRightCustom:
            returnValue = (
                <>
                <Box className='titlebar sub'>
                    <div className='left-icon'>
                        <img src='/images/common/app_bar_previous.png' onClick={histroyBack}></img>
                    </div> 
                    <div className="text-area">
                        <span>{props.title}</span>
                        {
                            props.pageGuide ? (
                                <img width="17px" height="17px" className="guide-btn" src="images/three_minute_counselor_list/info.png" alt="guid" onClick={() => {
                                    if(props.pageGuideButtonPressd){
                                        props.pageGuideButtonPressd();
                                    }
                                    navigate(props.pageGuide!);
                                }}/>
                            ) : <></>
                        }
                    </div>
                    <Box className='right-icon'>
                        {props.rightIcons}
                    </Box>
                </Box>
                <Spacing direction={SpacingType.vertical} gap={56}/>
                </>
            );
            break;
        case TitlebarType.SubOnlyRightButton:
            returnValue = (
                <>
                <Box className='titlebar sub'>
                    <div className='left-icon'>
                    </div> 
                    <div className="text-area">
                        <span>{props.title}</span>
                        {
                            props.pageGuide ? (
                                <img width="17px" height="17px" className="guide-btn" src="images/three_minute_counselor_list/info.png" alt="guid" onClick={() => {
                                    if(props.pageGuideButtonPressd){
                                        props.pageGuideButtonPressd();
                                    }
                                    navigate(props.pageGuide!);
                                }}/>
                            ) : <></>
                        }
                    </div>
                    <Box className='right-icon'>
                        {props.rightIcons}
                    </Box>
                </Box>
                <Spacing direction={SpacingType.vertical} gap={56}/>
                </>
            );
            break;
        case TitlebarType.FullPopup:
            returnValue = (
                <>
                <Box className='titlebar sub'>
                    <div className='left-icon'></div> 
                    <div className="text-area">
                        <span>{props.title}</span>
                        {
                            props.pageGuide ? (
                                <img width="17px" height="17px" className="guide-btn" src="images/three_minute_counselor_list/info.png" alt="guid" onClick={() => {
                                    if(props.pageGuideButtonPressd){
                                        props.pageGuideButtonPressd();
                                    }
                                    navigate(props.pageGuide!);
                                }}/>
                            ) : <></>
                        }
                    </div>
                    <Box className='right-icon'>
                        <div className="big-icon" onClick={histroyBack}>
                            <img src='images/common/app_bar_close.png'/>
                        </div>
                    </Box>
                </Box>
                <Spacing direction={SpacingType.vertical} gap={56}/>
                </>
            );
            break;
        case TitlebarType.NoneButton:
            returnValue = (
                <>
                <Box className='titlebar sub'>
                    <div className="text-area fullWidth">
                        <span>{props.title}</span>
                        {
                            props.pageGuide ? (
                                <img width="17px" height="17px" className="guide-btn" src="images/three_minute_counselor_list/info.png" alt="guid" onClick={() => {
                                    if(props.pageGuideButtonPressd){
                                        props.pageGuideButtonPressd();
                                    }
                                    navigate(props.pageGuide!);
                                }}/>
                            ) : <></>
                        }
                    </div>
                </Box>
                <Spacing direction={SpacingType.vertical} gap={56}/>
                </>
            );
            break;
        case TitlebarType.SubPageLeftCustom:
            returnValue = (
                <>
                <Box className='titlebar sub'>
                    <div className='left-icon'>
                        {props.leftIcons}
                    </div>
                    <div className="text-area">
                        <span>{props.title}</span>
                        {
                            props.pageGuide ? (
                                <img width="17px" height="17px" className="guide-btn" src="images/three_minute_counselor_list/info.png" alt="guid" onClick={() => {
                                    if(props.pageGuideButtonPressd){
                                        props.pageGuideButtonPressd();
                                    }
                                    navigate(props.pageGuide!);
                                }}/>
                            ) : <></>
                        }
                    </div>
                    <Box className='right-icon'>
                    </Box>
                </Box>
                <Spacing direction={SpacingType.vertical} gap={56}/>
                </>
            );
                break;
        default:
            returnValue = (<span></span>);
            break;

    }

    return returnValue;
};

enum TitlebarType {
    SubPageNoButton,
    SubPageOneButton,
    SubPageTwoButton,
    SubPageRightCustom,
    SubOnlyRightButton,
    SubPageLeftCustom,
    FullPopup,
    NoneButton,
    SajuMyeongsik,
    None
}

export {
    TitleBar,
    TitlebarType
};
